import * as React from "react";

import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

type PanelPadding = "sm" | "md" | "lg";

const paddingScale: Record<PanelPadding, string> = {
  sm: "p-4 sm:p-6",
  md: "p-6 sm:p-8",
  lg: "p-8 sm:p-10",
};

export interface PanelProps extends React.ComponentPropsWithoutRef<typeof Card> {
  padding?: PanelPadding;
}

/**
 * Thin wrapper over Card with opinionated padding and subtle backdrop styling
 * for auth/public surfaces.
 */
export function Panel({ className, padding = "md", ...props }: PanelProps) {
  return (
    <Card
      className={cn(
        "bg-white/95 text-foreground shadow-2xl backdrop-blur-sm",
        paddingScale[padding],
        className,
      )}
      {...props}
    />
  );
}
